// extracted by mini-css-extract-plugin
var _1 = "dndlX0NcBhWFycKZcXTf";
var _2 = "yAPja2i5ZH2GyI3gZayu";
var _3 = "mDAmwW4lfWLGBInOcvfb";
var _4 = "TM2Cb77L2ZKlfvFYp6Rw";
var _5 = "Sa6dtLDponPZIB74Sicg";
var _6 = "xe1vhdO_vZnKLOPN7sba";
var _7 = "OxTZOaal7be70msBjllM";
var _8 = "th0tuec8qTstsKcSHkEw";
var _9 = "qqTR_BSZQ60SjVrnbV3j";
var _a = "kAdtUos7D0QHaGlsWyMR";
export { _1 as "birch", _2 as "brown", _3 as "container", _4 as "contentContainer", _5 as "frameBottomLeft", _6 as "frameBottomRight", _7 as "frameTopLeft", _8 as "frameTopRight", _9 as "fullHeight", _a as "fullWidth" }
